import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import './RoiProjectionsCss.css'

function ROIProjectionsFormulas(props) {
    const {show} = props
    const [showModal, setShowModal] = useState(false);

    const modalClose = () => {
        props.handleClose()
        setShowModal(false);
    }

    useEffect(() => {
        if (!show) return
        setShowModal(true)
    }, [show])


    return (<Modal show={showModal} onHide={modalClose} centered dialogClassName="modal-70w prop-img-slider"
                   backdrop="static" keyboard={false}>
        <Modal.Header closeButton className="border-0 pb-0 modal-header">
            <Modal.Title className="fs-5 fw-bold">
                <span>ROI PROJECTION FORMULAS</span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
            <div className="py-2 tabs-border">
                <div className="wrap">
                    <section className="metric" id="capital-gains">
                        <h2>1. Capital Gains (Realized or Unrealized)</h2>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mtext>If sold:</mtext>
                                    <mspace width="0.6em"/>
                                    <mtext>Sale Price</mtext>
                                    <mo>−</mo>
                                    <mtext>Purchase Price</mtext>
                                </mrow>
                            </math>
                            <math>
                                <mrow>
                                    <mtext>If not sold:</mtext>
                                    <mspace width="0.6em"/>
                                    <mtext>Current Market Price</mtext>
                                    <mo>−</mo>
                                    <mtext>Purchase Price</mtext>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Understand appreciation and tax implications.
                        </p>
                    </section>
                    <section className="metric" id="roi">
                        <h2>2. Return on Investment (ROI)</h2>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mtext>If sold:</mtext>
                                    <mspace width="0.6em"/>
                                    <mrow>
                                        <mfrac>
                                            <mrow>
                                                <mtext>Sale Price</mtext>
                                                <mo>−</mo>
                                                <mtext>Purchase Price</mtext>
                                                <mo>+</mo>
                                                <mtext>Net Income</mtext>
                                            </mrow>
                                            <mrow>
                                                <mtext>Purchase Price</mtext>
                                            </mrow>
                                        </mfrac>
                                        <mo>×</mo>
                                        <mn>100</mn>
                                        <mo>%</mo>
                                    </mrow>
                                </mrow>
                            </math>
                            <math>
                                <mrow>
                                    <mtext>If held:</mtext>
                                    <mspace width="0.6em"/>
                                    <mrow>
                                        <mfrac>
                                            <mrow>
                                                <mtext>Current Market Price</mtext>
                                                <mo>−</mo>
                                                <mtext>Purchase Price</mtext>
                                                <mo>+</mo>
                                                <mtext>Net Income</mtext>
                                            </mrow>
                                            <mrow>
                                                <mtext>Purchase Price</mtext>
                                            </mrow>
                                        </mfrac>
                                        <mo>×</mo>
                                        <mn>100</mn>
                                        <mo>%</mo>
                                    </mrow>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Overall profitability assessment.</p>
                    </section>
                    <section className="metric" id="net-income">
                        <h2>3. Net Income</h2>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mtext>Net Income</mtext>
                                    <mo>=</mo>
                                    <mtext>Property Income</mtext>
                                    <mo>−</mo>
                                    <mtext>Property Expenses</mtext>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Understand cash flow from each property.</p>
                    </section>
                    <section className="metric" id="cap-rate">
                        <h2>4. Cap Rate (Capitalization Rate)</h2>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mfrac>
                                        <mrow>
                                            <mtext>Net Operating Income</mtext>
                                        </mrow>
                                        <mrow>
                                            <mtext>Current Market Price</mtext>
                                        </mrow>
                                    </mfrac>
                                    <mo>×</mo>
                                    <mn>100</mn>
                                    <mo>%</mo>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Measure income performance relative to market
                            value.
                        </p>
                        <p className="use"><strong>Note:</strong> A cap rate is a yield per year, so the numerator
                            is net operating income for a single calendar year &mdash; the latest complete calendar
                            year inside the selected date range, named above the grid. It is not accumulated since
                            purchase, unlike every other column here. Net operating income is rent and gross
                            short-term-rental income less operating expenses; loans, loan repayments, purchase
                            payment plans, security deposits and fines are excluded, which is what separates it
                            from the Net Income column. Where no current market price has been recorded there is no
                            denominator and the cell reads N/A.
                        </p>
                    </section>
                    {/*  The grid column is headed "Cash on Cash Return" and this section used to
                         restate the textbook cash-on-cash formula, net income over cash invested.
                         The column does not compute that and never has. ROIProjections.txt:187-190
                         is (IncomeAmount - ExpenseAmount) / PropertyPurchasePrice: the numerator is
                         cumulative net income rather than before-tax cash flow, and the denominator
                         is purchase cost rather than equity. Neither leg of cash-on-cash is present,
                         so the formula shown here is now the one that is actually computed. The
                         column header is a VM_Column.Caption database row and cannot be corrected
                         from this repository; this section and the note above the grid carry the
                         correction until it can be. */}
                    <section className="metric" id="cash-on-cash">
                        <h2>5. Cumulative Net Income Return on Cost</h2>
                        <p className="use"><strong>Shown in the grid as:</strong> Cash on Cash Return. That
                            header is wrong and is being corrected separately; the figure below is what the
                            column computes.
                        </p>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mfrac>
                                        <mrow>
                                            <mtext>Cumulative Net Income</mtext>
                                        </mrow>
                                        <mrow>
                                            <mtext>Purchase Cost</mtext>
                                        </mrow>
                                    </mfrac>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Measure how much of the purchase cost the
                            property has returned as net income since it was bought. Purchase cost is the
                            full acquisition cost &mdash; the price plus the brokerage, land-department,
                            trustee, notary, cadastre and registration fees entered against the purchase.
                        </p>
                        <p className="use"><strong>Note:</strong> This is a ratio, not a percentage &mdash;
                            0.42 means the property has returned 42 % of its purchase cost. It is a return
                            on <em>cost</em>, not on equity: the denominator is the whole purchase cost, not
                            the owner&rsquo;s cash contribution, so it is not cash-on-cash and it does not
                            respond to how the purchase was financed. <strong>The capital gain leg is not
                            included</strong> &mdash; only income net of expenses is &mdash; so this is not a
                            total return. For the gain leg see Capital Gains and Appreciation Rate.
                        </p>
                    </section>
                    <section className="metric" id="appreciation-rate">
                        <h2>6. Appreciation Rate</h2>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mfrac>
                                        <mrow>
                                            <mtext>Current Market Price</mtext>
                                            <mo>−</mo>
                                            <mtext>Purchase Price</mtext>
                                        </mrow>
                                        <mrow>
                                            <mtext>Purchase Price</mtext>
                                        </mrow>
                                    </mfrac>
                                    <mo>×</mo>
                                    <mn>100</mn>
                                    <mo>%</mo>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Assess long-term growth trend of property
                            value.
                        </p>
                    </section>
                    <section className="metric" id="valuation-gap">
                        <h2>7. Valuation Gap (Bank vs Market)</h2>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mtext>Bank Evaluation Price</mtext>
                                    <mo>−</mo>
                                    <mtext>Current Market Price</mtext>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Identify under- or over-valued assets based on
                            lending
                            institutions.</p>
                    </section>
                    <section className="metric" id="expense-ratio">
                        <h2>8. Expense Ratio</h2>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mfrac>
                                        <mrow>
                                            <mtext>Property Expenses</mtext>
                                        </mrow>
                                        <mrow>
                                            <mtext>Property Income</mtext>
                                        </mrow>
                                    </mfrac>
                                    <mo>×</mo>
                                    <mn>100</mn>
                                    <mo>%</mo>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Assess operational efficiency.</p>
                    </section>
                    <section className="metric" id="projected-sale-profit">
                        <h2>9. Projected Sale Profit (If planning to sell)</h2>
                        <div className="formula">
                            <math>
                                <mrow>
                                    <mtext>Estimated Sale Price</mtext>
                                    <mo>−</mo>
                                    <mtext>Purchase Price</mtext>
                                    <mo>−</mo>
                                    <mtext>Transaction Costs</mtext>
                                    <mo>+</mo>
                                    <mtext>Net Income</mtext>
                                </mrow>
                            </math>
                        </div>
                        <p className="use"><strong>Use:</strong> Scenario modeling for future liquidation.</p>
                    </section>
                    <div className={"col-sm-12"}>
                        <p style={{marginLeft: "15px"}}><strong>Note:</strong> If any field shows <code>N/A</code>, it
                            means one
                            or more
                            inputs needed for the formula are not available.</p>
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="pt-2">
            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                    onClick={modalClose}>
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>)
}

export default ROIProjectionsFormulas;